import React from "react";
import { mastercard, stripe, visa } from "../../assets/images";

import { isWeb } from "@stepapp/core";
import { Block, Image, SvgIcon, Typography, palette, useBreakpoints } from "@stepapp/ui";

import { useTranslation } from "react-i18next";
import { useAppLinks, useContactDetails } from "../../hooks";
import { AppStorage } from "../../services/AppStorage";
import { Grid } from "../Grid";
import FooterElement from "./FooterElement";

const WebFooter = () => {
  const { md, sm } = useBreakpoints();
  const { t } = useTranslation();
  const { Reviews, FAQ, Myths, Blog, Workers, TermsOfUse, PrivacyPolicy, CancellationRules } =
    useAppLinks();
  const { Email, Phone } = useContactDetails();

  const countryCode = AppStorage().get("countryCode");
  const isNorway = countryCode === "NO";

  return (
    <Block style={styles.footerContainer}>
      <Block alignCenter style={styles.container}>
        <Block justifyCenter flex={1} style={styles.content}>
          <Block paddingHorizontal={2} paddingVertical={8} style={styles.contentInner}>
            <Block marginBottom={8}>
              <Grid columns={md ? 4 : sm ? 2 : 1}>
                <Block flex={1}>
                  <SvgIcon color={palette.common.white} name="stepappLogo" />
                  <Block marginTop={sm ? 6 : 3}>
                    <Typography type="white" variant="paragraph">
                      {t("components.footer.safePayment")}
                    </Typography>

                    <Block row marginTop={2}>
                      <Image contentFit="contain" height={20} source={visa} width={32} />
                      <Block marginLeft={2}>
                        <Image contentFit="contain" height={20} source={mastercard} width={32} />
                      </Block>
                      <Block marginLeft={1}>
                        <Image contentFit="contain" height={20} source={stripe} width={40} />
                      </Block>
                    </Block>
                  </Block>
                </Block>

                <Block flex={1} marginTop={sm ? 0 : 4}>
                  <Block paddingBottom={1}>
                    <Typography type="white" variant="newH4">
                      {t("components.footer.about")}
                    </Typography>
                  </Block>
                  <FooterElement label={t("components.footer.reviews")} link={Reviews} />
                  <FooterElement label={t("components.footer.FAQ")} link={FAQ} />
                  {!isNorway && <FooterElement label={t("components.footer.myths")} link={Myths} />}
                  <FooterElement label={t("components.footer.cleaningPersonnel")} link={Workers} />
                  <FooterElement label={t("components.footer.blog")} link={Blog} />
                </Block>

                <Block flex={1} marginTop={md ? 0 : 4}>
                  <Block paddingBottom={1}>
                    <Typography type="white" variant="newH4">
                      {t("components.footer.worthKnowing")}
                    </Typography>
                  </Block>
                  <FooterElement label={t("components.footer.termsOfUse")} link={TermsOfUse} />
                  <FooterElement
                    label={t("components.footer.privacyPolicy")}
                    link={PrivacyPolicy}
                  />
                  <FooterElement
                    label={t("components.footer.cancellationRules")}
                    link={CancellationRules}
                  />
                </Block>

                <Block flex={1} marginTop={md ? 0 : 4}>
                  <Block paddingBottom={1}>
                    <Typography type="white" variant="newH4">
                      {t("components.footer.contact")}
                    </Typography>
                  </Block>
                  <FooterElement label={Email} />
                  {isNorway && <FooterElement label={Phone} />}
                  <FooterElement label={t("components.footer.contactHours")} />
                </Block>
              </Grid>
            </Block>

            <Typography type="white" variant="lightLabel">
              {isNorway ? t("components.footer.disclaimerNO") : t("components.footer.disclaimerPL")}
            </Typography>
          </Block>
        </Block>
      </Block>
    </Block>
  );
};

export default React.memo(WebFooter);

const styles = {
  contentInner: {
    maxWidth: "100%",
  },
  footerContainer: {
    zIndex: isWeb ? -100 : 0,
  },
  container: {
    width: "100%",
    backgroundColor: palette.common.black,
  },
  content: {
    maxWidth: 1160,
    width: "100%",
  },
};
